import { defineMessages } from 'react-intl';

export default defineMessages({
  requiredMessage: {
    id: 'common.requiredMessage',
    defaultMessage: '*Campi obbligatori',
    description: 'Message for required input text field',
  },
  yesLabel: {
    id: 'common.yes',
    defaultMessage: 'Sì',
    description: 'Positive label',
  },
  noLabel: {
    id: 'common.no',
    defaultMessage: 'No',
    description: 'Negative label',
  },
  placeholderDateInput: {
    id: 'common.placeholderTextInput',
    defaultMessage: 'GG/MM/AAAA',
    description: 'placeholder DateInput',
  },
  labelFrom: {
    id: 'common.labelFrom',
    defaultMessage: 'Da:',
    description: 'label From',
  },
  labelTo: {
    id: 'common.labelTo',
    defaultMessage: 'A:',
    description: 'label To',
  },
});
